import addCouponAction from './actions/add-coupon.js'
import removeCouponAction from './actions/remove-coupon.js'
import addProductAction from './actions/add-product.js'
import replaceProductAction from './actions/replace-product.js'
import removeProductAction from './actions/remove-product.js'
import ClearCartItemsAction from './actions/clear-cart-items.js'
import cancelClickAction from './actions/cancel-click.js'
import modifyDataAction from './actions/modify-data.js'

export default function (eventBus) {
    eventBus.$on('cart-rule-action:add_coupon', addCouponAction)
    eventBus.$on('cart-rule-action:remove_coupon', removeCouponAction)
    eventBus.$on('cart-rule-action:add_product', addProductAction)
    eventBus.$on('cart-rule-action:replace_product', replaceProductAction)
    eventBus.$on('cart-rule-action:remove_product', removeProductAction)
    eventBus.$on('cart-rule-action:clear_cart_items', ClearCartItemsAction)
    eventBus.$on('cart-rule-action:cancel_click', cancelClickAction)
    eventBus.$on('cart-rule-action:modify_data', modifyDataAction)
}
